import { render, staticRenderFns } from "./CalloutText.vue?vue&type=template&id=cf7db0ee&"
import script from "./CalloutText.vue?vue&type=script&lang=js&"
export * from "./CalloutText.vue?vue&type=script&lang=js&"
import style0 from "./CalloutText.vue?vue&type=style&index=0&id=cf7db0ee&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports